module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-quiz_green.c5dbc97b.svg";